import { UserService, ApiResponse } from '../types';
import { UserResponse } from '../../model';
import { BaseService } from '../base-service';

export class UserServiceReal extends BaseService implements UserService {
  constructor() {
    super('UserService');
  }

  async getCurrentUser(): Promise<ApiResponse<UserResponse>> {
    this.log('getCurrentUser');
    return this.makeRequest<UserResponse>('/user/profile');
  }

  async updateUserPreferences(preferences: Record<string, any>): Promise<ApiResponse<boolean>> {
    this.log('updateUserPreferences', preferences);

    const response = await this.makeRequest<any>('/user/preferences', {
      method: 'PUT',
      body: JSON.stringify({ preferences }),
    });

    return {
      ...response,
      data: response.success,
    };
  }
}
